import { handleReturnGameURL } from './common/utils';

import { checkIsMobile } from '../../../../common/utils';
import { Game } from '../../types';

const isMobile = checkIsMobile();

const games: Game[] = [
  {
    name: 'Fish Hunter',
    src: {
      full: 'https://cdn.tain.com/demo/casino/high-quality/fishhunter.png',
      thumbnail: 'https://cdn.tain.com/demo/casino/low-quality/fishhunter.png'
    },
    modes: ['fun'],
    method: handleReturnGameURL,
    urlData: {
      id: '1006',
      provider: 'TAIN',
      channel: 'desktop.fish_hunter',
      url: 'https://fishhunter.tain.com/en/'
    }
  },
  {
    name: 'Roulette Deluxe',
    src: {
      full: 'https://cdn.tain.com/demo/casino/high-quality/roulette.png',
      thumbnail: 'https://cdn.tain.com/demo/casino/low-quality/roulette.png'
    },
    modes: ['fun', 'real'],
    method: handleReturnGameURL,
    urlData: {
      id: 'european_roulette_deluxe',
      provider: 'TAIN_NXT',
      channel: isMobile ? 'mobile' : 'desktop.html5'
    }
  },
  {
    name: 'Blackjack Deluxe 3H',
    src: {
      full: 'https://cdn.tain.com/demo/casino/high-quality/blackjack.png',
      thumbnail: 'https://cdn.tain.com/demo/casino/low-quality/blackjack.png'
    },
    modes: ['fun', 'real'],
    method: handleReturnGameURL,
    urlData: {
      id: 'blackjack_3h_deluxe',
      provider: 'TAIN_NXT',
      channel: isMobile ? 'mobile' : 'desktop.html5'
    }
  },
  {
    name: 'Blackjack Deluxe 5H',
    src: {
      full: 'https://cdn.tain.com/demo/casino/high-quality/blackjack.png',
      thumbnail: 'https://cdn.tain.com/demo/casino/low-quality/blackjack.png'
    },
    modes: ['fun', 'real'],
    method: handleReturnGameURL,
    urlData: {
      id: 'blackjack_5h_deluxe',
      provider: 'TAIN_NXT',
      channel: 'desktop.html5'
    }
  },
  {
    name: 'Baccarat Deluxe 5H',
    src: {
      full: 'https://cdn.tain.com/demo/casino/high-quality/baccarat-deluxe.png',
      thumbnail: 'https://cdn.tain.com/demo/casino/low-quality/baccarat-deluxe.png'
    },
    modes: ['fun', 'real'],
    method: handleReturnGameURL,
    urlData: {
      id: 'baccarat_5h_deluxe',
      provider: 'TAIN_NXT',
      channel: isMobile ? 'mobile' : 'desktop.html5'
    }
  },
  {
    name: 'Baccarat Super 6 Deluxe',
    src: {
      full: 'https://cdn.tain.com/demo/casino/high-quality/baccarat-super-6.png',
      thumbnail: 'https://cdn.tain.com/demo/casino/low-quality/baccarat-super-6.png'
    },
    modes: ['fun', 'real'],
    method: handleReturnGameURL,
    urlData: {
      id: 'baccarat_super_6_5h_deluxe',
      provider: 'TAIN_NXT',
      channel: isMobile ? 'mobile' : 'desktop.html5'
    }
  },
  {
    name: 'Fortune Dragon',
    src: {
      full: 'https://cdn.tain.com/demo/casino/high-quality/fortunedragon.png',
      thumbnail: 'https://cdn.tain.com/demo/casino/low-quality/fortunedragon.png'
    },
    modes: ['fun', 'real'],
    method: handleReturnGameURL,
    urlData: {
      id: 'fortune_dragon',
      provider: 'TAIN_NXT',
      channel: isMobile ? 'mobile' : 'desktop.html5'
    }
  },
  {
    name: 'Hunting Season',
    src: {
      full: 'https://cdn.tain.com/demo/casino/high-quality/huntingseason.png',
      thumbnail: 'https://cdn.tain.com/demo/casino/low-quality/huntingseason.png'
    },
    modes: ['fun', 'real'],
    method: handleReturnGameURL,
    urlData: {
      id: 'hunting_season_hd',
      provider: 'TAIN_NXT',
      channel: isMobile ? 'mobile' : 'desktop.html5'
    }
  }
];

export default games;
